import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse  } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { FunctService } from './funct.service';
import { DtoService } from './dto.service';
import { TranslateService } from '@ngx-translate/core';
import { interval, Subscription } from 'rxjs';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})

export class MaintenanceService {

  private subscription: Subscription;

  public dateNow = new Date();
  dDay: any;
  currentTime: any;
  toTime: any;
  milliSecondsInASecond = 1000;
  hoursInADay = 24;
  minutesInAnHour = 60;
  SecondsInAMinute  = 60;
  duration: any;

  public timeDifference: any;
  public secondsToDday: any;
  public minutesToDday: any;
  public hoursToDday: any;
  public daysToDday: any;

  constructor(
    private funct: FunctService,
    private translateService: TranslateService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private dto: DtoService,
    private storage: LocalStorageService) { 
  
  }

  private errorMsg(tit: string, msg: string, position: string, translatedMsg?: string, noTranslateMsg?: string) {

    let title = tit != "" ? this.translateService.instant(tit) : "";
    let message = msg != "" ? this.translateService.instant(msg) : translatedMsg != "" ? translatedMsg : noTranslateMsg;

    this.toastr.error(title, message, {
      positionClass: `toast-${position}-center`,
      timeOut: 2000,
      toastClass: 'toast-yellow ngx-toastr'
    });
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status == 423) {
      this.errorMsg("", "youNeedLogin", "top");
      this.storage.store('token', '');
      this.storage.store('isUserLoggedIn', false);
      return;

    } else if (error.status == 400) {
      this.errorMsg("", "bad_request", "top");
      return;

    }
    // return throwError(error);
  }


  private closeMaintenance = () => {
    let headers = new HttpHeaders();
    this.http.get(this.funct.ipaddress + 'gameProvider/CloseMaintenance', { headers: headers })
    .pipe(
      catchError(this.handleError.bind(this))
    )
    .subscribe(
      result => {
        this.spinner.show("refreshLoading");
        if (result.status === 'Success') {
          this.storage.store('isMaintenance', false)
          setTimeout(() => {
            window.location.reload();
            this.spinner.hide("refreshLoading");
          }, 1000);
        }
    })
  }

  private getTimeDifference () {
    const timeLeft = moment.duration(this.dDay.diff(moment())); 
    this.secondsToDday = timeLeft.seconds();
    this.minutesToDday = timeLeft.minutes().toLocaleString(undefined,{minimumIntegerDigits: 2});
    this.hoursToDday = timeLeft.hours().toLocaleString(undefined,{minimumIntegerDigits: 2});
  }

  getMaintenanceTime(gameAlertObject: any) {
    
    const newTime = new Date()
    this.currentTime = moment(newTime, 'hh:mm')
    this.toTime = moment(gameAlertObject.toTime, 'hh:mm')
    
    if (this.toTime.isBefore(this.currentTime)) { 
      this.toTime = moment(gameAlertObject.toTime, 'hh:mm').add(24, 'hours');
      // this.toTime = moment("10:45", 'h:mm').add(24, 'hours');
      this.dDay = this.toTime;
    } else {
      this.dDay = this.toTime;
    }

    this.subscription = interval(1000)
      .subscribe(x => {  
        if (this.secondsToDday <= 0) {
          this.closeMaintenance()
          
          this.subscription.unsubscribe();
        } else {
          this.getTimeDifference()
        }
      });
  }

}
